import { defineEffect } from '../../../core/effect';

/**
 * **ターンの切り替え**（Issue #538）。画面の中央に「TURN n」。
 *
 * あわせて**前のターンに残っていた印を消す**（対象・処理中。Issue #534）——
 * 消すのは閉じるイベントの仕事（設計文書 §1.2）。
 *
 * 旧 `components/fx` では `target.js` が `build` で**未来のイベント**を探して `endRow` を
 * 決めていたが、1 ファイル = 1 イベントではその必要が無い。
 */
const COLOR = '#ffd76a';

export default defineEffect({
  situation: 'new_turn',
  label: 'ターン',
  color: COLOR,
  sounds: () => [{ at: 0, name: 'turn_change' }],
  /** ターンが変わったら舞台の設定も素に戻す（Issue #535） */
  scene: 'reset',

  /** `key` を省くとその印を**全部**消す（綴りは器が組むので知らなくてよい） */
  clears: () => [{ mark: 'target' }, { mark: 'processing' }],

  layers: [
    {
      id: 'band',
      label: '光の帯',
      part: 'beam',
      at: { screen: [960, 540] },
      props: { color: COLOR, core: 0.34 },
      tf: {
        scale: { keys: [{ ms: 0, value: 0.2 }, { ms: 220, value: 1.1, ease: 'ease_out' }, { ms: 1400, value: 1.1 }, { ms: 1600, value: 0.2 }] },
        opacity: { keys: [{ ms: 0, value: 0 }, { ms: 180, value: 1 }, { ms: 1400, value: 1 }, { ms: 1600, value: 0 }] },
      },
    },
    {
      id: 'label',
      label: 'TURN n',
      part: 'text',
      parent: 'band',
      props: { text: 'TURN {turn}', size: 150, color: '#fff' },
      tf: {
        scale: { keys: [{ ms: 220, value: 0.55 }, { ms: 560, value: 0.42, ease: 'ease_out' }] },
        opacity: { keys: [{ ms: 220, value: 0 }, { ms: 400, value: 1 }, { ms: 1320, value: 1 }, { ms: 1500, value: 0 }] },
      },
    },
  ],
}, 'new_turn_effect.js');
